(function initSwitcherContainer() {
  $('.switcher-container').map(function () {
    let $container = $(this);
    let $navItems = $container.find('.switcher-nav .nav-item');
    let $navItemsLinks = $container.find('.switcher-nav .nav-link');
    let $panes = $container.find('.switcher-pane');

    $navItemsLinks.on('click', function(e){
      e.preventDefault();
      $navItems.removeClass('active');
      $(this).closest($navItems).addClass('active');

      $panes.removeClass('active');
      $panes.eq($(this).closest($navItems).index()).addClass('active');
    });
  });
})();
